import { render, staticRenderFns } from "./ContestWhatComponent.vue?vue&type=template&id=79d82eda"
import script from "./ContestWhatComponent.vue?vue&type=script&lang=js"
export * from "./ContestWhatComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestWhatComponent.vue?vue&type=style&index=0&id=79d82eda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports